/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/pricesMappers";
import * as Parameters from "../models/parameters";
/** Class representing a Prices. */
var Prices = /** @class */function () {
  /**
   * Create a Prices.
   * @param {LabsApiClientContext} client Reference to the service client.
   */
  function Prices(client) {
    this.client = client;
  }
  Prices.prototype.list = function (region, options, callback) {
    return this.client.sendOperationRequest({
      region: region,
      options: options
    }, listOperationSpec, callback);
  };
  Prices.prototype.listNext = function (nextPageLink, options, callback) {
    return this.client.sendOperationRequest({
      nextPageLink: nextPageLink,
      options: options
    }, listNextOperationSpec, callback);
  };
  return Prices;
}();
export { Prices };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var listOperationSpec = {
  httpMethod: "GET",
  path: "{region}/api/prices",
  urlParameters: [Parameters.region],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: Mappers.PagedLabServicesPrices
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var listNextOperationSpec = {
  httpMethod: "GET",
  baseUrl: "https://labs.azure.com",
  path: "{nextLink}",
  urlParameters: [Parameters.nextPageLink],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: Mappers.PagedLabServicesPrices
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};